/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { ResourceInterface } from '@app/shared/models/resource.interface';
import { HttpClient } from '@angular/common/http';
import { ApiQuery } from '@app/core/http/api-query';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { map } from 'rxjs/operators';
import { HttpResponse } from '@app/core';
import { Country } from '@app/settings/countries/countries.model';
import { Model } from '@app/shared/models/model.model';

@Injectable({
  providedIn: 'root',
})
export class CountriesService implements ResourceInterface {
  constructor(private http: HttpClient) {}

  index(query: ApiQuery = new ApiQuery()): Observable<PaginatedResponse> {
    return this.http
      .cache()
      .get('v1/countries', query.buildGetOptions())
      .pipe(
        map((response: HttpResponse) => {
          response.data = response.data.map((country: any) => {
            return new Country().deserialize(country);
          });

          return new PaginatedResponse().deserialize(response);
        })
      );
  }

  update(country: Country): Observable<Country> {
    return this.http.put('v1/countries/' + country.id, country).pipe(
      map((response: HttpResponse) => {
        return new Country().deserialize(response.data);
      })
    );
  }

  store(country: Country): Observable<Country> {
    return this.http.post('v1/countries', country).pipe(
      map((response: HttpResponse) => {
        return new Country().deserialize(response.data);
      })
    );
  }

  show(id: number, query: ApiQuery = new ApiQuery()): Observable<Model> {
    return this.http.get('v1/countries/' + id, query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        return new Country().deserialize(response.data);
      })
    );
  }

  destroy(id: number): Observable<any> {
    return this.http.delete('v1/countries/' + id);
  }

  updateTranslations(country: Country, translations: any): Observable<any> {
    return this.http.put('v1/countries/translations/' + country.id, translations).pipe(
      map((response: HttpResponse) => {
        return response;
      })
    );
  }
}
